export default "__VITE_ASSET__BDbaJoA9__"